import { FiClock, FiUsers } from "react-icons/fi";
import Button from "../Button";
import { Link } from "react-router-dom";

const LiveTournamentCard = ({
  title,
  status,
  statusType,
  timeInfo,
  participants,
  prize,
  problems,
  difficulty,
  buttonText,
  buttonLink,
}) => {
  return (
    <div className="col-md-6 col-12 mb-4">
      <div className="rounded-lg border text-card-foreground shadow-sm bg-dark-secondary border-primary hover-card h-100">
        <div className="p-4">
          {/* Header */}
          <div className="d-flex justify-content-between align-items-start mb-3">
            <h5 className="fw-bold text-light mb-0">{title}</h5>
            <span className={`badge bg-${statusType}`}>{status}</span>
          </div>

          {/* Time & Participants */}
          <div className="row mx-0 mb-3">
            <div className="col d-flex align-items-center text-muted">
              <FiClock className="me-2" />
              <small>{timeInfo}</small>
            </div>
            <div className="col d-flex align-items-center text-muted">
              <FiUsers className="me-2" />
              <small>{participants} participants</small>
            </div>
          </div>

          {/* Prize & Problems */}
          <div className="row mx-0 mb-3">
            <div className="col">
              <small className="text-muted">Prize Pool</small>
              <div className="text-accent fw-bold">{prize}</div>
            </div>
            <div className="col">
              <small className="text-muted">Problems</small>
              <div className="text-light">{problems}</div>
            </div>
          </div>

          {/* Difficulty & Button */}
          <div className="d-flex justify-content-between align-items-center">
            <span className={`badge bg-${difficulty.toLowerCase()}`}>
              {difficulty}
            </span>
            {/* <button className="btn btn-outline-primary text-white " >
              {buttonText}
            </button> */}
            <Link to={`/Tournaments/${title}`}>
            <Button variant="gradient">
              {buttonText}
            </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveTournamentCard;